import React, { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { useEffect } from 'modules/core/hooks/useEffect'
import { Collection, Model, apiClient } from 'modules/core/lib/mobx-rest'

import PageLoading from 'modules/layout/components/Page/Loading'

export type CollectionBootstrapConfig = [Collection<Model>, object]

interface Props extends React.PropsWithChildren {
  collections: CollectionBootstrapConfig[]
  loadingFallback?: React.ReactElement | null
}

export const fetchCollections = (collections: CollectionBootstrapConfig[]) => {
  return Promise.all(
    collections
      .filter(([collection]) => !collection.fetching)
      .map(([collection, data]) => collection.fetch({ data, withCachedFetchParams: true }))
  )
}

export const CollectionsBootstrap = ({
  children,
  collections,
  loadingFallback = (
    <Box width="full" height="full" justifyContent="center" alignItems="center">
      <PageLoading />
    </Box>
  ),
}: Props) => {
  const client = apiClient()
  const [state, setState] = useState<{ loading: boolean; error: unknown }>({
    loading: collections.some(
      ([collection, data]) => !client.cache.read(client.cache.identify(collection), data)
    ),
    error: null,
  })

  useEffect(() => {
    const bootstrap = async () => {
      try {
        await fetchCollections(collections)
        setState({ loading: false, error: null })
      } catch (error) {
        setState({ loading: false, error })
      }
    }

    if (state.loading) {
      bootstrap()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (state.loading) {
    return loadingFallback
  }

  if (state.error) {
    throw state.error
  }

  return <>{children}</>
}
